import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSiteUrl } from 'core/selectors/app';
import orgConfig from 'org/configs/org.config';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import { triggerEducationalTileIsViewed } from 'core/modules/Instore2/actions';

import config from '../configs';

function LinkOffersTile({ tileViewClassName }) {
  const { linkOffersInstoreLabel } = config;
  const dispatch = useDispatch();
  const tileRef = useRef();
  const { earnType } = orgConfig;
  const siteUrl = useSelector(selectSiteUrl);

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerEducationalTileIsViewed());
  useTriggerSectionIsViewedGaEvent(tileRef, dispatchTriggerSectionIsViewed);

  return (
    <a
      ref={tileRef}
      className={`mn_instoreEducationalTile mn_linkOffersTile ${tileViewClassName}`}
      href={`${siteUrl}/instore`}
    >
      <div className="mn_educationalTileContent">
        <div className="mn_icon" />
        <div className="mn_description">
          <div className="mn_info">
            Link offers to earn {earnType} <span className="mn_noWrap">on {linkOffersInstoreLabel}</span> purchases
            <span className="mn_dot">.</span>
          </div>
          <div className="mn_cta">View all offers</div>
        </div>
      </div>
    </a>
  );
}

export default LinkOffersTile;
